import * as React from 'react';

const DirectorySettings = React.lazy(() => import('./container'));

export default () => <DirectorySettings />;
